module.exports = __webpack_public_path__ + "img/cc.c13f3d31.svg";